import { ArrayUtil, LogManager } from "@mcleod/core";
import { ChangeEvent, Layout, Panel, Tree, TreeNode } from "@mcleod/components";
import { WebRouter } from "@mcleod/common";
import { ComponentDemoFactory } from "./components/ComponentDemoFactory";
import { DemoDefinition } from "./DemoDefinition";
import { DemoRegistry } from "./DemoRegistry";

const log = LogManager.getLogger("component-demo.Demo");

export class Demo extends Layout {
    private treeDemo: Tree;
    private router: WebRouter;
    private panelContent: Panel;

    onLoad() {
        this.addTreeChangeListener();
        this.router = new WebRouter({ isMainDocumentRouter: false, id: "demoRouter" });
        this.loadDemos();
        this.panelContent.add(this.router);
        this.selectFirstTreeNode();

        // Are you working on a demo page and want it to load without having to select it?  Put the text of each node in
        // the path of the node you wish to select.  For example, to select the 'Tooltips' page under 'Concepts', set
        // the nodesText array equal to [ "Concepts", "Tooltips" ]
        /*
        const nodesText = ["Concepts", "Tooltips"];
        nodesText.forEach(text => {
            const node = this.treeDemo.findNodeWithText(text);
            if (node) {
                this.treeDemo.selectedNode = node;
                this.treeDemo.setNodeExpanded(node, true, null);
            }
        });
         */
    }

    private addTreeChangeListener() {
        this.treeDemo.addChangeListener((event: ChangeEvent) => {
            const selectedNode = ArrayUtil.getFirstElement(event.newValue);
            const runtimePath = selectedNode?.data?.runtimePath;
            if (runtimePath == null) {
                log.debug("Clearing demo router");
                this.router.removeAll();
            }
            else {
                const demoRoute = `component-demo/${runtimePath}`;
                log.debug("Displaying demo at route: %o", demoRoute);
                this.router.displayRoute(demoRoute);
            }
        });
    }

    private loadDemos() {
        new ComponentDemoFactory().registerComponentDemos();
        DemoRegistry.get().getAll().forEach(demo => {
            log.debug("Adding demo to tree: %o", demo);
            this.addDemoToTree(demo);
        });
        this.treeDemo.sort();
    }

    private addDemoToTree(demoDefinition: DemoDefinition) {
        const path = demoDefinition.treePath;
        let parentNode = this.treeDemo.getRootNode();
        for (let i = 0; i < path.length; i++) {
            let childNode = parentNode.getChildWithText(path[i]);
            if (childNode == null)
                childNode = parentNode.addChild(new TreeNode({ text: path[i], tree: this.treeDemo }));
            if (i === path.length - 1) {
                childNode.imageName = demoDefinition.imageName;
                childNode.data = { runtimePath: demoDefinition.runtimePath };
            }
            parentNode = childNode;
        }
    }

    private selectFirstTreeNode() {
        if (this.treeDemo.getRootNode().getChildCount() > 0) {
            this.treeDemo.selectedNode = this.treeDemo.getRootNode().getChild(0);
            this.treeDemo.focus();
        }
    }
}
